import React from "react";
import i18n from "../../i18n";

import {
  checkForControlCenter,
  getDepotFilter,
  getDepotUsersSectionFilter,
  getShiftsFilter,
  getShiftsHistoryFilter,
  getUsersFilteredByDepotId,
  sortItemsByProp,
  sortUsers,
} from '../filter';
import {
  currentUserIsSupervisorRole,
  getFullName,
  getTimePerPeriod,
  isRTL,
  isShowControlCenterSearch,
} from '../userModel';
import {getInitModel} from "../initModels";
import {getAmountForType, getDeliveredDate, getFormattedDeliveryDuration} from "../order";
import {createControlModel} from "../controlModelFactory";

import SectionModel from "../../models/sectionModel";
import FilterOptionsModel, {FILTER_OPTION_TYPE} from '../../models/filterOptionsModel';

import User from "../user.js";

import {
  USER_CURRENT_SHIFTS,
  USER_SHIFT_COURIERS_CSV,
  USER_SHIFT_DOWNLOAD_PDF,
  USER_SHIFT_DOWNLOAD_REPORT,
  USER_SHIFT_HISTORY,
  USER_SHIFTS,
} from '../../store/reducers/userModel/userModel-actions';
import {
  CURRENT_SHIFT_USERS, GET_PROVIDER_SHIFT_HISTORY,
  GET_USER_SHIFT_HISTORY,
  SHIFT_PROVIDERS,
  SHIFT_PROVIDERS_GET,
  SHIFTS_GET,
} from '../../store/reducers/restaurant/restaurant-actions';

import {
  CONTROL_STYLE_TYPE,
  CONTROL_TYPE,
  COURIER_STATE,
  DATECONTROL_TYPE, EXTERNAL_CYCLE_STATE, FILTER_TYPE,
  getCurrencyIcons,
  getExternalCourierProviderName, getExternalCourierState,
  MODEL_CONTROL_TYPE,
  MODEL_TYPE,
  SHIFT_TYPE_VALUES,
  SHIFTS_MODEL, TYPE_ACTION,
  USER_FILTER_ROLES,
  getCourierShiftTypes,
  SALARY_CALCULATION_TYPE_VALUES,
  getCourierPaymentTypes, getCourierActiveTypes, ReportType,
} from '../../utils/enums';
import {
  DATE_FORMAT, DATE_FORMAT_DMY2_HM, DATE_FORMAT_DMY_SHORT, DATE_TIME_FORMAT_DAYTIME,
  getFormattedDate, getRelativeStartEndTime,
  getStaticTime,
  prepareToday,
  TIME_FORMAT_USER,
} from '../../utils/convertTime';

import StatusOrder from "../../app/components/StatusOrder";
import OrderTitleInfo from "../../app/components/OrderTitleInfo";
import {Avatar} from "../../app/components/Avatar/Avatar";
import {
  getControlCenterNameById,
  getCourierNameByShiftId,
  getExternalCycleLogoByProvider,
  getHistoryCourierNameByShiftHistory, getProviderNameById, getSelectedControlCenterMulti, getShiftNameById,
  isMobileWidth,
} from '../restaurant';
import CourierShiftControl from "../../app/components/CourierShiftControl/CourierShiftControl";
import {createBreadcrumbModel} from "../createBreadcrumbModel";
import {getHistoryLocationParams} from '../../utils/routesHelper';
import TextWithTooltip from '../../app/components/TextWithTooltip';
import CurrentShiftCourierEdit from '../../app/components/CurrentShiftCourierEdit';
import CurrentShiftDepotAssign from '../../app/components/CurrentShiftDepotAssign';
import Pusher from '../pusher';
import {getUserRole} from '../../utils/auth-util.js';
import ServiceProviderHistoryOrders from "../../app/components/ServiceProviderHistoryOrders/index.js";
import moment from "moment";
import {fixedNumber} from "../../utils/math-util.js";
import ExportFileControl from "../../app/components/ExportFileControl/ExportFileControl.jsx";
import { Tooltip } from "antd";

export function createShiftsSectionModel() {
  return new SectionModel({
    filterOptions: createShiftsSectionFilter(),
    skipUpdateFilterOptions: true,
    columns: [
      {
        width: '150px',
        fixedWidth: '150px',
        title: "shifts.WORKER_NAME_LABEL",
        isHideDeleteButton: item => item.isProvider,
        component: function(shift) {
          if(shift.isProvider) {
            const name = getExternalCourierProviderName(shift);
            return <Tooltip className='itemWithTooltip' title={name}>
              <span>{name}</span>
            </Tooltip>
          } else {
            return <Tooltip className='itemWithTooltip' title={shift.courierName}>
              <span>{shift.courierName}</span>
            </Tooltip>
          }
        },
      },
      {
        width: '100px',
        fixedWidth: '100px',
        title: "shifts.START_DATE_LABEL",
        component: function(shift) {
          return (
            getFormattedDate(shift.startDate, DATE_FORMAT_DMY_SHORT) ||
            i18n.t("shifts.ACTIVE_LABEL")
          );
        },
        centered: true,
      },
      {
        width: '100px',
        fixedWidth: '100px',
        title: "shifts.START_TIME_LABEL",
        component: function(shift) {
          return (
            getFormattedDate(shift.startDate, TIME_FORMAT_USER) ||
            i18n.t("shifts.ACTIVE_LABEL")
          );
        },
        centered: true,
      },
      {
        width: '100px',
        fixedWidth: '100px',
        title: "shifts.END_DATE_LABEL",
        component: function(shift) {
          return (
            getFormattedDate(shift.endDate, DATE_FORMAT_DMY_SHORT) ||
            i18n.t("shifts.ACTIVE_LABEL")
          );
        },
        centered: true,
      },
      {
        width: '100px',
        fixedWidth: '100px',
        title: "shifts.END_TIME_LABEL",
        component: function(shift) {
          return (
            getFormattedDate(shift.endDate, TIME_FORMAT_USER) ||
            i18n.t("shifts.ACTIVE_LABEL")
          );
        },
        centered: true,
      },
      {
        title: "shifts.SHIFT_TYPE",
        width: '115px',
        fixedWidth: '115px',
        component: (shift) => (
          <div>
            {SHIFT_TYPE_VALUES()[shift.shiftType]}
          </div>
        ),
        centered: true
      },
      {
        title: "settings.users.SALARY_PAYMENT_TYPE",
        width: '200px',
        fixedWidth: '100px',
        component: (shift) => (
          <div>
            {SALARY_CALCULATION_TYPE_VALUES()[shift.salaryCalculationMode]}
          </div>
        ),
        centered: true
      },
      {
        width: '10%',
        fixedWidth: '10%',
        title: "shifts.VEHICLE_PLATE_ID_LABEL",
        accessor: "vehiclePlateId",
        centered: true,
      },
      {
        width: '15%',
        fixedWidth: '15%',
        title: "shifts.NOTES_LABEL",
        accessor: "notes",
        centered: true,
      },
      {
        width: '80px',
        fixedWidth: '80px',
        title: "shifts.ADVANCED_PAYMENT_LABEL",
        accessor: "advancePayment",
        centered: true,
      },
      {
        width: '100px',
        fixedWidth: '100px',
        title: "shifts.HOURS_PER_DAY_LABEL",
        component: function(shift, onLayout, onPropChange, items, filterOptions) {
          const dateEnd = filterOptions.options.endDate.selected;
          const min = Math.min(new Date(), new Date(dateEnd));
          return getTimePerPeriod({startDate: shift.startDate, endDate: shift.endDate ? shift.endDate : new Date(min)});
        },
        centered: true,
      },
      {
        title: "",
        width: "40px",
        fixedWidth: "40px",
        hideInHeader: true,
        skipOverflow: true,
        component: function(shift) {
          return (
            <ExportFileControl
              ghostButton
              hideText
              horizontal
              canSavePdfReport
              control={{action: USER_SHIFT_DOWNLOAD_REPORT, reportType: ReportType.CourierShift}} 
              model={shift}
            />
          );
        },
      },
      {
        title: "",
        width: "45px",
        fixedWidth: "45px",
        hideInHeader: true,
        type: CONTROL_TYPE.link,
        link: SHIFTS_MODEL.shiftHistory,
        iconName: "eyeIcon",
        iconFullWH: true,
        tooltipText: i18n.t("shifts.SHIFTS_HISTORY"),
      },
      {
        width: "40px",
        fixedWidth: "40px",
        type: CONTROL_TYPE.link,
        link: SHIFTS_MODEL.historyEdit,
        iconName: "editItem",
        isShow: shift => shift.endDate,
        tooltipText: i18n.t("settings.users.USER_TOOLS_EDIT_TOOLTIP"),
      },
      {
        title: '',
        width: "40px",
        fixedWidth: "40px",
        hideInHeader: true,
        isShow: shift => !shift.endDate,
        component: (user) => (
            <CurrentShiftCourierEdit courier={user} updateHistoryShift actionName={SHIFTS_GET} />
        ),
      }
    ],
    key: "shiftId",
    label: 'shifts.HISTORY',
    breadcrumbs: [createBreadcrumbModel({ label: 'header.menu.SHIFTS_LABEL' })],
    actionName: USER_SHIFTS,
    footer: "shiftsSummary",
    hideHeaderItemControls: true,
    tableMinWidth: 1200,
    typeModel: SHIFTS_MODEL.history,
    isForceUpdate: true,
    controls: [
      createControlModel({
        action: USER_SHIFT_COURIERS_CSV,
        type: MODEL_CONTROL_TYPE.exportFile,
        reportType: ReportType.Couriers,
      })
    ],
    mappingLambda: state => {
      const selectedControlCenterIds = state.restaurant.data.selectedControlCenterMulti || [];
      const depots = state.restaurant.data.depots;
      const users = state.userModel.data.filter(user =>
          user.cycle
          && (!!selectedControlCenterIds.length && user?.cycle?.controlCenterId ? checkForControlCenter(user.cycle, selectedControlCenterIds) : true)
      );

      const couriers = users.map(user => ({
        depotsNames: depots.filter(depot => user?.cycle?.allowedDepots?.includes(depot.id)) || '-',
        shiftId: user.cycle?.shiftId || '-',
        showControlCenterName: selectedControlCenterIds.length !== 1,
        ...user,
      }));

      return (state.restaurant.data.shifts || []).reduce((acc, shift) => {
        const find = couriers.find(c => c.shiftId === shift.shiftId);
        return find && !shift.endDate ? acc.concat({...shift, userId: find.userId, cycle: {...shift, ...find.cycle}}) : acc.concat(shift);
      }, []);
    },
    actionLoad: SHIFTS_GET
  });
}

export function createShiftsEditSectionModel({ ...args }) {
  return new SectionModel({
    key: "shiftId",
    columns: [
      {
        title: "shifts.START_DATE_LABEL",
        accessor: "startDate",
        isEditable: currentUserIsSupervisorRole(),
        isReadonly: !currentUserIsSupervisorRole(),
        type: CONTROL_TYPE.date
      },
      {
        title: "shifts.START_TIME_LABEL",
        isReadonly: !currentUserIsSupervisorRole(),
        isEditable: currentUserIsSupervisorRole(),
        accessor: "startDate",
        timeType: DATECONTROL_TYPE.time,
        type: CONTROL_TYPE.date
      },
      {
        title: "shifts.END_DATE_LABEL",
        accessor: "endDate",
        isReadonly: !currentUserIsSupervisorRole(),
        isEditable: currentUserIsSupervisorRole(),
        type: CONTROL_TYPE.date
      },
      {
        title: "shifts.END_TIME_LABEL",
        accessor: "endDate",
        isReadonly: !currentUserIsSupervisorRole(),
        isEditable: currentUserIsSupervisorRole(),
        timeType: DATECONTROL_TYPE.time,
        type: CONTROL_TYPE.date
      },
      {
        title: "shifts.NOTES_LABEL",
        accessor: "notes",
        isEditable: true,
        type: CONTROL_TYPE.text
      },
      {
        title: "shifts.ADVANCED_PAYMENT_LABEL",
        accessor: "advancePayment",
        isEditable: true,
        type: CONTROL_TYPE.text
      },
      {
        title: "shifts.VEHICLE_PLATE_ID_LABEL",
        accessor: "vehiclePlateId",
        isEditable: true,
        type: CONTROL_TYPE.number
      },
      {
        title: "shifts.SAVE_BUTTON",
        isEditable: true,
        accessor: "shiftId",
        actionName: USER_SHIFT_DOWNLOAD_PDF,
        type: CONTROL_TYPE.linkDownload,
        className: "mt30",
      }
    ],
    actionName: USER_SHIFTS,
    initNewItemModel: item => getInitModel(MODEL_TYPE.shifts, item),
    typeAction: args.typeAction,
    breadcrumbs: [
        createBreadcrumbModel({label: 'header.menu.SHIFTS_LABEL'}),
        createBreadcrumbModel({label: 'shifts.HISTORY'}),
    ],
    getLabel: () => {
      const {id} = getHistoryLocationParams(window.location.search);
      return id ? getShiftNameById(id) : '-'
    },
    typeModel: SHIFTS_MODEL.historyEdit,
    parentUrl: SHIFTS_MODEL.history,
    mappingLambda: state => state.restaurant.data.shifts || [],
    actionLoad: SHIFTS_GET
  });
}

export function createShiftHistorySectionModel({ ...args }) {
  return new SectionModel({
    filterOptions: createShiftHistorySectionFilter(),
    columns: [
      {
        title: "couriers.NAME_TABLE_TITLE",
        width: "300px",
        component: function(order) {
          return (<div className="overflowNextRowText"><OrderTitleInfo order={order} /></div>);
        }
      },
      {
        title: "couriers.ORDER_ID",
        width: "80px",
        component: function(order) {
          return (<div className="overflowNextRowText">{`${order.orderId || ''}`}</div>);
        },
        isShow: () => !User.instance.getCurrentUserConfigurationProp("isHideOrderId"),
      },
      {
        title: "couriers.DRIVER_BASE_FEE",
        width: "80px",
        component: function(order) {
          return (<div className="overflowNextRowText">{order?.driverBaseFee ? `${fixedNumber(order?.driverBaseFee, 2)}${getCurrencyIcons(order.currency)}` : '-'}</div>);
        },
        hideWidth: "570"
      },
      {
        title: "couriers.DRIVER_FEE_INCREASE",
        width: "80px",
        component: function(order) {
          return (<div className="overflowNextRowText">{order?.driverFeeIncrease ? `${fixedNumber(order?.driverFeeIncrease * 100, 2)}%` : '-'}</div>);
        },
        hideWidth: "570"
      },
      {
        title: "couriers.COMPENSATION",
        width: "120px",
        component: function(order) {
          return (<div className="overflowNextRowText">{order.compensation ? `${fixedNumber(order.compensation, 2)}${getCurrencyIcons(order.currency)}` : '-'}</div>);
        },
        hideWidth: "570"
      },
      {
        title: "couriers.PAYMENT_CASH",
        width: "80px",
        component: function(order) {
          return (<div className="overflowNextRowText">{`${getAmountForType(order, true)}${getCurrencyIcons(order.currency)}`}</div>);
        },
        hideWidth: "570"
      },
      {
        title: "couriers.PAYMENT_CREDIT_CARD",
        width: "100px",
        component: function(order) {
          return (<div className="overflowNextRowText">{`${getAmountForType(order)}${getCurrencyIcons(order.currency)}`}</div>);
        },
        hideWidth: "570"
      },
      {
        title: "couriers.DELIVERY_TIME_TABLE_TITLE",
        width: "120px",
        component: function(order) {
          return (<div className="overflowNextRowText">{getFormattedDeliveryDuration(order, true)}</div>);
        },
        hideWidth: "570"
      },
      {
        title: "couriers.DELIVERY_AT_TABLE_TITLE",
        width: "150px",
        component: function(order) {
          return (<div className="overflowNextRowText">{getStaticTime(getDeliveredDate(order), isRTL())}</div>);
        }
      },
      {
        title: "couriers.STATUS_TABLE_TITLE",
        width: "80px",
        component: function(order) {
          return <StatusOrder order={order} />;
        }
      }
    ],
    actionName: USER_SHIFT_HISTORY,
    actionLoad: GET_USER_SHIFT_HISTORY,
    urlNewItem: SHIFTS_MODEL.shiftHistory + `/new${args.params}`,
    showDeleteButton: false,
    hideHeaderItemControls: true,
    footer: "shiftsHistorySummary",
    typeModel: SHIFTS_MODEL.shiftHistory,
    parentUrl: SHIFTS_MODEL.history,
    label: 'shifts.HISTORY',
    breadcrumbs: [
      createBreadcrumbModel({ label: 'header.menu.SHIFTS_LABEL' }),
      createBreadcrumbModel({ label: 'shifts.HISTORY' }),
      createBreadcrumbModel({
        getLabel: () => {
          const { id } = getHistoryLocationParams(window.location.search);
          return getCourierNameByShiftId(id) || getHistoryCourierNameByShiftHistory();
        },
      })
    ],
    controls: [createControlModel({ type: MODEL_CONTROL_TYPE.back })],
    mappingLambda: state => {
      const depots = state.restaurant?.data?.depots || []
      const orders = state.restaurant.data.shiftsHistory
        ? state.restaurant.data.shiftsHistory.orders || []
        : []

      return orders?.map(order => ({
        ...order,
        depotName: depots?.find(depot => depot?.id === order?.depotId)?.name || ''
      }))
    },
  })
}

export function createCurrentShiftUsersSectionModel() {
  return new SectionModel({
    filterOptions: createCurrentShiftUsersSectionFilter(),
    isForceUpdate: true,
    hideHeaderItemControls: true,
    columns: [
      {
        title: "invitation.USERNAME_LABEL",
        width: '185px',
        fixedWidth: '185px',
        component: function(user) {
          return <div className="shiftAvatar"><Avatar avatar={user.avatarUrl} color={user.color} title={getFullName(user) || user.name}/></div>;
        },
        accessor: 'avatarUrl',
        type: CONTROL_TYPE.image,
      },
      {
        title: "assistance.DEPOT_LABEL",
        width: '170px',
        fixedWidth: '170px',
        component: (user) => {
          const names = user?.depotsNames?.map(depot => depot.name)
          return names && <div className={'overflowHiddenText'}>
            {names.join(', ')}
          </div>
        },
      },
      {
        title: "shifts.CONTROL_CENTER",
        width: '170px',
        fixedWidth: '170px',
        isShow: user => {
          return user.showControlCenterName;
        },
        component: (user) => {
          return user?.cycle?.controlCenterId ? getControlCenterNameById(user?.cycle?.controlCenterId) : '';
        },
      },
      {
        width: '120px',
        fixedWidth: '120px',
        title: "shifts.START_DATE_LABEL",
        component: function(user) {
          return (
            getFormattedDate(user.cycle?.startTime, DATE_FORMAT) ||
            i18n.t("shifts.ACTIVE_LABEL")
          );
        },
        centered: true,
        isShow: () => false,
      },
      {
        title: "shifts.START_TIME_LABEL",
        width: '100px',
        fixedWidth: '100px',
        component: function(user) {
          return (
            getFormattedDate(user.cycle?.startTime, TIME_FORMAT_USER) ||
            '-'
          );
        },
        centered: true,
        isShow: () => false,
      },
      {
        width: '120px',
        fixedWidth: '120px',
        title: "shifts.END_DATE_LABEL",
        component: function(user) {
          return (
            getFormattedDate(user.cycle?.endTime, DATE_FORMAT) ||
            i18n.t("shifts.ACTIVE_LABEL")
          );
        },
        centered: true,
        isShow: () => false,
      },
      {
        title: "shifts.DURATION_TIME_LABEL",
        width: '100px',
        fixedWidth: '100px',
        component: function(user) {
          return (
            user.cycle ? getRelativeStartEndTime(user.cycle.startTime, user.cycle.endTime || new Date(), true): '-'
          );
        },
        centered: true,
      },
      {
        title: "shifts.SHIFT_TYPE",
        width: '100px',
        fixedWidth: '100px',
        component: (user) => (
          <div>
            {SHIFT_TYPE_VALUES()[user.cycle.shiftType]}
          </div>
        ),
        centered: true
      },
      {
        title: "settings.users.SALARY_PAYMENT_TYPE",
        width: '200px',
        fixedWidth: '100px',
        component: (user) => (
          <div>
            {SALARY_CALCULATION_TYPE_VALUES()[user.cycle.salaryCalculationMode]}
          </div>
        ),
        centered: true
      },
      {
        title: ''
      },
      {
        title: "shifts.ACTIONS",
        width: "160px",
        // textRight: true,
        // textAlign: isRTL() ? 'left' : 'right',
      },
      {
        title: "",
        width: "40px",
        fixedWidth: "40px",
        skipOverflow: true,
        component: function(user) {
          return (
              <ExportFileControl
                ghostButton
                hideText
                horizontal
                canSavePdfReport
                control={{action: USER_SHIFT_DOWNLOAD_REPORT, reportType: ReportType.CourierShift}} 
                model={user}
              />
          );
        },
        hideInHeader: true,
        isShow: user => !!user.cycle
      },
      {
        title: "",
        width: "45px",
        fixedWidth: "45px",
        type: CONTROL_TYPE.link,
        iconFullWH: true,
        link: SHIFTS_MODEL.currentShiftHistory,
        iconName: "eyeIcon",
        tooltipText: i18n.t("shifts.SHIFTS_HISTORY"),
        hideInHeader: true,
      },
      {
        title: '',
        width: "40px",
        fixedWidth: "40px",
        hideInHeader: true,
        component: (user) => (
          <CurrentShiftCourierEdit courier={user} />
        ),
      },
      {
        title: '',
        width: '40px',
        fixedWidth: "40px",
        component: (user) => (
              <div>
                <CourierShiftControl userId={user.userId} type={COURIER_STATE.endShift} />
              </div>
        ),
        type: CONTROL_TYPE.linkIconComponent,
        wrapOnMobileWidth: '992',
        link: 'courierShiftControl',
        hideInHeader: true,
      }
    ],
    key: "shiftId",
    actionName: USER_SHIFTS,
    actionLoad: CURRENT_SHIFT_USERS,
    typeModel: SHIFTS_MODEL.currentShiftUsers,
    tableMinWidth: 1200,
    hideCellForSort: true,
    label: 'shifts.CURRENT_SHIFT',
    breadcrumbs: [createBreadcrumbModel({ label: 'header.menu.SHIFTS_LABEL' })],
    controls: [
      createControlModel({
        type: MODEL_CONTROL_TYPE.add,
        openCourierShiftPopup: true
      }),
      createControlModel({
        type: MODEL_CONTROL_TYPE.back,
        isShow: isMobileWidth,
      }),
      createControlModel({
        type: MODEL_CONTROL_TYPE.filter
      }),
    ],
    mappingLambda: state => {
      const selectedControlCenterIds = state.restaurant.data.selectedControlCenterMulti || [];
      const depots = state.restaurant.data.depots;
      const users = state.userModel.data.filter(user =>
          user.cycle
          && (!!selectedControlCenterIds.length && user?.cycle?.controlCenterId ? checkForControlCenter(user.cycle, selectedControlCenterIds) : true)
      );

      const couriers = users.map(user => ({
        depotsNames: depots.filter(depot => user?.cycle?.allowedDepots?.includes(depot.id)) || '-',
        shiftId: user.cycle?.shiftId || '-',
        showControlCenterName: selectedControlCenterIds.length !== 1,
        ...user,
      }))

      return couriers;
    },
  });
}

export function createSummaryShiftProviderSectionModel() {
  return new SectionModel({
    filterOptions: createShiftsProviderSectionFilter(),
    showFilterValueInHeader: [{
      filterOptionName: 'dateStart',
      formatData: (data) => data && moment(data).format(DATE_TIME_FORMAT_DAYTIME)
    }, {
      filterOptionName: 'endDate',
      formatData: (data) => data && moment(data).format(DATE_TIME_FORMAT_DAYTIME)
    }],
    skipUpdateFilterOptions: true,
    isForceUpdate: true,
    columns: [
      {
        title: "shifts.PROVIDER_NAME_LABEL",
        width: '185px',
        fixedWidth: '185px',
        component: function(user) {
          return <Avatar
              avatar={user.avatarUrl || getExternalCycleLogoByProvider(user.provider)}
              color={user.color}
              title={user.name || user.providerId}
          />;
        },
      },
      {
        title: "shifts.COUNT",
        width: '250px',
        fixedWidth: '250px',
        accessor: 'count',
        centered: true
      },
      {
        title: "shifts.TOTAL_PRICE_LABEL",
        width: '250px',
        fixedWidth: '100px',
        component: function(user) {
          return `${user.totalPrice} ${getCurrencyIcons(user.currency)}`
        },
        centered: true
      },
      {
        title: "shifts.TOTAL_ORDERS_LABEL",
        accessor: 'totalOrders',
        centered: true,
      },
      {
        title: "shifts.ACTIONS",
        width: "50px",
        fixedWidth: "50px",
        headerWidth: "120px",
        skipOverflow: true,
        component: function(shift) {
          return (
            <ExportFileControl
              ghostButton
              hideText
              horizontal
              control={{action: USER_SHIFT_DOWNLOAD_REPORT, reportType: ReportType.CourierProvider}} 
              model={{...shift, id: shift.providerId, isProvider: true}}
            />
          );
        },
      },
      {
        title: "",
        width: "50px",
        fixedWidth: "50px",
        type: CONTROL_TYPE.link,
        link: SHIFTS_MODEL.currentShiftProviderHistory,
        iconName: "eyeIcon",
        tooltipText: i18n.t("shifts.SHIFTS_PROVIDER_HISTORY"),
        hideInHeader: true,
      },
    ],
    sortByFunc: function(items) {
      return sortItemsByProp(items, "providerId");
    },
    key: "providerId",
    actionName: SHIFT_PROVIDERS,
    actionLoad: SHIFT_PROVIDERS_GET,
    typeModel: SHIFTS_MODEL.providers,
    tableMinWidth: 1200,
    isHideControls: true,
    hideHeaderItemControls: true,
    hideCellForSort: true,
    label: 'shifts.PROVIDERS',
    breadcrumbs: [createBreadcrumbModel({ label: 'header.menu.SHIFTS_LABEL' })],
    controls: [
      createControlModel({
        type: MODEL_CONTROL_TYPE.back,
        isShow: isMobileWidth,
      }),
      createControlModel({
        type: MODEL_CONTROL_TYPE.filter
      }),
    ],
    mappingLambda: state => {
      const providers = state.restaurant.data.shiftProviders || [];
      const ordersProvider = state.restaurant.data.ordersProvider || [];
      return providers.map(provider => {
        const find = ordersProvider.find(p => p.id === provider.providerId);
        return {
          ...find,
          ...provider,
        }
      });
    },
  });
}

export function createCurrentShiftEditSectionModel({ ...args }) {
  return new SectionModel({
    isForceUpdate: true,
    columns: [
      {
        title: "shifts.START_TIME_LABEL",
        accessor: "startTime",
        isEditable: true,
        timeType: DATECONTROL_TYPE.time,
        type: CONTROL_TYPE.date
      },
      {
        title: "shifts.END_TIME_LABEL",
        accessor: "endTime",
        isEditable: true,
        timeType: DATECONTROL_TYPE.time,
        type: CONTROL_TYPE.date
      },
      {
        title: 'Allowed depots',
        accessor: "allowedDepots",
        isEditable: true,
        type: CONTROL_TYPE.allowedDepotsList,
      },
      {
        title: "shifts.SAVE_BUTTON",
        isEditable: true,
        accessor: "shiftId",
        actionName: USER_SHIFT_DOWNLOAD_PDF,
        type: CONTROL_TYPE.linkDownload,
        isShow: item => !!item.shiftId
      }
    ],
    actionName: USER_CURRENT_SHIFTS,
    initNewItemModel: user => getInitModel(MODEL_TYPE.currentShift, user),
    typeAction: args.typeAction,
    stayAfterSave: true,
    typeModel: SHIFTS_MODEL.currentShiftDepotEdit,
    parentUrl: SHIFTS_MODEL.currentShiftUsers,
    mappingLambda: state => {
      const { id } = getHistoryLocationParams(window.location.search);
      const users = getUsersFilteredByDepotId(state.userModel.data, false)
      return users.find(user => user.userId === id)
    }
  });
}


export function createCurrentShiftHistorySectionModel({...args}) {
  return new SectionModel({
    filterOptions: createShiftHistorySectionFilter(),
    columns: [
      {
        title: "couriers.NAME_TABLE_TITLE",
        width: "400px",
        component: function(order) {
          return (<div className="overflowNextRowText"><OrderTitleInfo order={order} /></div>);
        }
      },
      {
        title: "shifts.ORDER_ID",
        width: "80px",
        component: function(order) {
          return (<div className="overflowNextRowText">{order.orderId}</div>);
        },
        hideWidth: "570"
      },
      {
        title: "couriers.DRIVER_BASE_FEE",
        width: "80px",
        component: function(order) {
          return (<div className="overflowNextRowText">{order?.driverBaseFee ? `${fixedNumber(order?.driverBaseFee, 2)}${getCurrencyIcons(order.currency)}` : '-'}</div>);
        },
        hideWidth: "570"
      },
      {
        title: "couriers.DRIVER_FEE_INCREASE",
        width: "80px",
        component: function(order) {
          return (<div className="overflowNextRowText">{order?.driverFeeIncrease ? `${fixedNumber(order?.driverFeeIncrease * 100, 2)}%` : '-'}</div>);
        },
        hideWidth: "570"
      },
      {
        title: "couriers.COMPENSATION",
        width: "120px",
        component: function(order) {
          return (<div className="overflowNextRowText">{order.compensation ? `${fixedNumber(order.compensation, 2)}${getCurrencyIcons(order.currency)}` : '-'}</div>);
        },
        hideWidth: "570"
      },
      {
        title: "couriers.PAYMENT_CASH",
        width: "80px",
        component: function(order) {
          return (<div className="overflowNextRowText">{`${getAmountForType(order, true)}${getCurrencyIcons(order.currency)}`}</div>);
        },
        hideWidth: "570"
      },
      {
        title: "couriers.PAYMENT_CREDIT_CARD",
        width: "100px",
        component: function(order) {
          return (<div className="overflowNextRowText">{`${getAmountForType(order)}${getCurrencyIcons(order.currency)}`}</div>);
        },
        hideWidth: "570"
      },
      {
        title: "couriers.DELIVERY_TIME_TABLE_TITLE",
        width: "120px",
        component: function(order) {
          return (<div className="overflowNextRowText">{getFormattedDeliveryDuration(order)}</div>);
        },
        hideWidth: "570"
      },
      {
        title: "couriers.DELIVERY_AT_TABLE_TITLE",
        width: "150px",
        component: function(order) {
          return (<div className="overflowNextRowText">{getStaticTime(getDeliveredDate(order), isRTL())}</div>);
        }
      },
      {
        title: "couriers.STATUS_TABLE_TITLE",
        width: "80px",
        component: function(order) {
          return <StatusOrder order={order} />;
        }
      }
    ],
    showDeleteButton: false,
    footer: "shiftsHistorySummary",
    hideHeaderItemControls: true,
    actionLoad: GET_USER_SHIFT_HISTORY,
    typeModel: SHIFTS_MODEL.currentShiftHistory,
    parentUrl: SHIFTS_MODEL.currentShiftUsers,
    label: 'shifts.HISTORY',
    breadcrumbs: [
      createBreadcrumbModel({ label: 'header.menu.SHIFTS_LABEL' }),
      createBreadcrumbModel({ label: 'shifts.PROVIDERS' }),
      createBreadcrumbModel({
        getLabel: () => {
          const { id } = getHistoryLocationParams(window.location.search);
          return getCourierNameByShiftId(id);
        },
      })
    ],
    controls: [createControlModel({ type: MODEL_CONTROL_TYPE.back })],
    mappingLambda: state => {
      const { id } = getHistoryLocationParams(window.location.search);
      const depots = state.restaurant?.data?.depots || []
      const orders = state.restaurant.data.shiftsHistory
          ? state.restaurant.data.shiftsHistory.orders || []
          : []

      const ordersWithDepotName = orders.map(order => ({
        ...order,
        depotName: depots?.find(depot => depot?.id === order?.depotId)?.name || ''
      }))

      return id === state.restaurant.data?.shiftsHistory?.id ? ordersWithDepotName : []
    }
  });
}

export function createCurrentShiftHistoryTripSectionModel({...args}) {
  return new SectionModel({
    filterOptions: createShiftHistoryTripSectionFilter(),
    fixScroll: true,
    actionPagination: GET_PROVIDER_SHIFT_HISTORY,
    paginationKey: 'id',
    columns: [
      {
        title: "couriers.COURIER_NAME_TABLE_TITLE",
        component: function(order) {
          return (<div className="overflowNextRowText">{order.driverInfo?.name || '-'}</div>);
        }
      },
      {
        title: "couriers.CONTROL_CENTER_TABLE_TITLE",
        component: function(order) {
          return (<div className="overflowNextRowText">{order.controlCenterName}</div>);
        }
      },
      {
        title: 'couriers.ORDERS_TABLE_TITLE',
        accessor: '',
        component: (item) => {
          return <ServiceProviderHistoryOrders orderIds={item.ordersIds} />
        },
      },
      {
        title: "couriers.DISTANCE_TABLE_TITLE",
        component: function(order) {
          return (<div className="overflowNextRowText">{order.priceInfo?.distance || '-'}</div>);
        },
      },
      {
        title: "couriers.PRICE_TABLE_TITLE",
        component: function(order) {
          return (<div className="overflowNextRowText">{fixedNumber(order.priceInfo?.price || '0', 2)} {getCurrencyIcons(order.priceInfo?.currency)}</div>);
        },
      },
      {
        title: "couriers.START_DATE_TABLE_TITLE",
        component: function(order) {
          return (<div className="overflowNextRowText">{getFormattedDate(order.startTime, DATE_FORMAT_DMY2_HM) || '-'}</div>);
        }
      },
      {
        title: "couriers.CONFIRM_DATE_TABLE_TITLE",
        component: function(order) {
          return (<div className="overflowNextRowText">{getFormattedDate(order.confirmDate, DATE_FORMAT_DMY2_HM) || '-'}</div>);
        }
      },
      {
        title: "couriers.END_DATE_TABLE_TITLE",
        component: function(order) {
          return (<div className="overflowNextRowText">{getFormattedDate(order.endDate, DATE_FORMAT_DMY2_HM) || '-'}</div>);
        }
      },
      {
        title: "couriers.STATUS_TABLE_TITLE",
        component: function(order) {
          return (<div className="overflowNextRowText">{getExternalCourierState(order.state)}</div>);
        }
      },
    ],
    showDeleteButton: false,
    hideCellForSort: true,
    hideHeaderItemControls: true,
    footer: "shiftsHistoryTripSummary",
    typeModel: SHIFTS_MODEL.currentShiftHistory,
    parentUrl: SHIFTS_MODEL.providers,
    label: 'shifts.HISTORY',
    breadcrumbs: [
      createBreadcrumbModel({ label: 'header.menu.SHIFTS_LABEL' }),
      createBreadcrumbModel({ label: 'shifts.PROVIDERS' }),
      createBreadcrumbModel({
        getLabel: () => {
          const { id } = getHistoryLocationParams(window.location.search);
          return getProviderNameById(id);
        },
      })
    ],
    controls: [
        createControlModel({ type: MODEL_CONTROL_TYPE.back }),
        createControlModel({ type: MODEL_CONTROL_TYPE.filter }),
    ],
    mappingLambda: state => {
      const controlCenters = state.restaurant.data.controlCenters || [];
      const orders = state.restaurant.data.shiftsTrip
        ? state.restaurant.data.shiftsTrip.orders || []
        : [];
      return orders.map(order => {
        const findControl = controlCenters.find(cc => cc.controlCenterId === order.controlCenterId);
        return {...order, controlCenterName: findControl?.name || ''}
      });
    }
  });
}

export function createCurrentShiftHistoryOrdrsModel({...args}) {
  return new SectionModel({
    columns: [{
      title: "couriers.NAME_TABLE_TITLE",
      width: "400px",
      accessor: 'id',
      component: (model) => {
        return <ServiceProviderHistoryOrders orderIds={model.ordersIds} />
      }
    }],
    initNewItemModel: (item) => item,
    isHideControls: true,
    isHideSaveButton: true,
    hideHeaderItemControls: true,
    isLayoutForm: true,
    typeModel: SHIFTS_MODEL.currentShiftProviderHistoryOrder,
    parentUrl: SHIFTS_MODEL.currentShiftProviderHistory,
    typeAction: TYPE_ACTION.edit,
    mappingLambda: (state, id) => {
      const orders = state.restaurant.data.shiftsTrip
          ? state.restaurant.data.shiftsTrip.orders || []
          : [];
      return orders;
    }
  })
}

export function createCurrentShiftDepotsSectionModel() {
  return new SectionModel({
    filterOptions: createCurrentShiftDepotsSectionFilter(),
    isForceUpdate: true,
    hideHeaderItemControls: true,
    columns: [
      {
        title: "",
        width: '52px',
        fixedWidth: '52px',
        component: function(depot) {
          return <Avatar avatar={depot.logoUrl} color={depot.color} />;
        },
        type: CONTROL_TYPE.image,
      },
      {
        title: 'settings.map.DEPOT_EDIT_NAME_LABEL',
        accessor: 'name',
        width: '200px',
        fixedWidth: '200px',
        component: depot => <TextWithTooltip text={depot.name} tooltip={depot.name} />,
      },
      {
        title: "controlCenters.SELECT_COURIERS_LABEL",
        component: (depot) => {
          const names = depot.users.map(user => getFullName(user))
          return names.join(', ')
        }
      },
      {
        title: 'controlCenters.CHOOSE_COURIER',
        width: '150px',
        // hideInHeader: true,
        centered: true,
        component: (depot) => (
            <CurrentShiftDepotAssign depot={depot} />
        ),
        isShow: item => !item.isProvider,
      },
    ],
    key: "businessId",
    actionName: USER_SHIFTS,
    typeModel: SHIFTS_MODEL.currentShiftUsers,
    tableMinWidth: 1200,
    hideCellForSort: true,
    label: 'shifts.CURRENT_SHIFT',
    breadcrumbs: [createBreadcrumbModel({ label: 'header.menu.SHIFTS_LABEL' })],
    controls: [
      createControlModel({
        type: MODEL_CONTROL_TYPE.add,
        openCourierShiftPopup: true
      }),
      createControlModel({
        type: MODEL_CONTROL_TYPE.back,
        isShow: isMobileWidth,
      }),
      createControlModel({
        type: MODEL_CONTROL_TYPE.filter
      }),
    ],
    mappingLambda: state => {
      const depots = state.restaurant.data.depots || []
      const users = state.userModel.data
      const allowedDepotsUsers = users.filter(user => user?.cycle?.allowedDepots);
      return depots.map(depot => ({
        users: allowedDepotsUsers.filter(user => user ? user.cycle.allowedDepots.includes(depot.id) : '-'),
        ...depot
      }))
    },
    sortByFunc: items => sortUsers(items)
  });
}


function createCurrentShiftUsersSectionFilter() {
  let filterOptionsModel = new FilterOptionsModel();

  filterOptionsModel.addOptions("search", CONTROL_TYPE.text, null, function(
    user
  ) {
    return getDepotUsersSectionFilter(this.selected, user);
  });

  //Control centers
  let selectControlCenterOption = filterOptionsModel.addOptions("controlCenterIds", CONTROL_TYPE.multiselect, i18n.t("shifts.CONTROL_CENTER"));
  selectControlCenterOption.selected = Pusher.instance.getControlCenterMultiChannel() || [];
  selectControlCenterOption.mappingLambda = state =>
      sortUsers((state.restaurant && state.restaurant.data && state.restaurant.data.controlCenters) || [])
          .map(controlCenter=> ({
                key: controlCenter.name,
                value: controlCenter.controlCenterId
              })
          );
  selectControlCenterOption.isShow = isShowControlCenterSearch;

  const shiftTypeFilter = filterOptionsModel.addOptions(
    "shiftType",
    CONTROL_TYPE.select,
    i18n.t("shifts.SHIFT_TYPE"),
    function(item) {
      if(this.selected === null) {
        return true;
      }
      return this.selected === item.cycle.shiftType;
    },
    null,
    null,
    null,
    true
  );
  shiftTypeFilter.filterType = FILTER_TYPE.and;
  shiftTypeFilter.addItem(i18n.t("shifts.ALL"), null);
  getCourierShiftTypes().forEach(({key, value}) => {
    shiftTypeFilter.addItem(value, key);
  });
  const salaryTypeFilter = filterOptionsModel.addOptions(
    "salaryCalculationMode",
    CONTROL_TYPE.select,
    i18n.t("settings.users.SALARY_PAYMENT_TYPE"),
    function(item) {
      if(this.selected === null) {
        return true;
      }
      return this.selected === item.cycle.salaryCalculationMode;
    },
    null,
    null,
    true
  );
  salaryTypeFilter.filterType = FILTER_TYPE.and;
  getCourierPaymentTypes().forEach(({key, value}) => {
    salaryTypeFilter.addItem(value, key);
  });

  return filterOptionsModel;
}
function createCurrentShiftDepotsSectionFilter() {
  let filterOptionsModel = new FilterOptionsModel();

  filterOptionsModel.addOptions("search", CONTROL_TYPE.text, null, function(
    depot
  ) {
    return getDepotFilter(this.selected, depot);
  });

  return filterOptionsModel;
}

function createShiftsSectionFilter() {
  let filterOptionsModel = new FilterOptionsModel();

  filterOptionsModel.addOptions("search", CONTROL_TYPE.text, null, function(
    shift
  ) {
    return getShiftsFilter(this.selected, shift);
  });

  filterOptionsModel.addOptions(
      "dateLink",
      CONTROL_TYPE.dateLink,
      "shifts.START_DATE_LABEL",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      {
        startKey: "dateStart",
        endKey: "endDate",
      },
  );

  filterOptionsModel.addOptions(
    "dateStart",
    CONTROL_TYPE.date,
    "shifts.START_DATE_LABEL",
    null,
    null,
    null,
    true
  );

  filterOptionsModel.addOptions(
    "endDate",
    CONTROL_TYPE.date,
    "shifts.END_DATE_LABEL",
    null,
    null,
    null,
    true
  );

  //Users
  filterOptionsModel.addOptions(
    "user",
    CONTROL_TYPE.usersPopup,
    i18n.t("shifts.USER"),
    null,
    null,
    null,
    true
    );

   const shiftTypeFilter = filterOptionsModel.addOptions(
      "shiftType",
      CONTROL_TYPE.select,
      i18n.t("shifts.SHIFT_TYPE"),
      null,
      null,
      null,
      true
      );
      shiftTypeFilter.addItem(i18n.t("shifts.ALL"), null);
      getCourierShiftTypes().forEach(({key, value}) => {
        shiftTypeFilter.addItem(value, key);
      });

      const salaryTypeFilter = filterOptionsModel.addOptions(
        "salaryCalculationMode",
        CONTROL_TYPE.select,
        i18n.t("settings.users.SALARY_PAYMENT_TYPE"),
        null,
        null,
        null,
        true
        );
        getCourierPaymentTypes().forEach(({key, value}) => {
          salaryTypeFilter.addItem(value, key);
        });

    const activeTypeFilter = filterOptionsModel.addOptions(
      "activeShifts",
      CONTROL_TYPE.select,
      i18n.t("shifts.ACTIVE_TYPE"),
        null,
        null,
        null,
        true
    );
    getCourierActiveTypes().forEach(({key, value}) => {
      activeTypeFilter.addItem(value, key);
    });

  //Control centers
  let selectControlCenterOption = filterOptionsModel.addOptions('controlCenterIds', CONTROL_TYPE.multiselect, i18n.t("shifts.CONTROL_CENTER"));
  selectControlCenterOption.selected = [];
  selectControlCenterOption.mappingLambda = state => sortUsers((state.restaurant && state.restaurant.data && state.restaurant.data.controlCenters) || [])
    .map(controlCenter=> ({
      key: controlCenter.name,
      value: controlCenter.controlCenterId
    }));
  selectControlCenterOption.isShow = isShowControlCenterSearch;


  //use filter state
  const filterState = Pusher.instance.getShiftHistoryFilterStateChannel() || {}
  for(let key in filterState){
    filterOptionsModel.options[key].selected = filterState[key]?.selected ? filterState[key]?.selected : null
  }

  const selectedControlCenter = getSelectedControlCenterMulti();
  if(selectedControlCenter.length === 1) {
    filterOptionsModel.options["controlCenterIds"].selected = selectedControlCenter;
  }

  const {from, to} = prepareToday();
  filterOptionsModel.options["dateStart"].selected = from;
  filterOptionsModel.options["endDate"].selected = to;

  return filterOptionsModel;
}

function createShiftsProviderSectionFilter() {
  let filterOptionsModel = new FilterOptionsModel();

  filterOptionsModel.addOptions(
      "dateLink",
      CONTROL_TYPE.dateLink,
      "",
      null,
      false,
      null,
      false,
      null,
      CONTROL_STYLE_TYPE.inline,
      null,
      null,
      {
        startKey: "dateStart",
        endKey: "endDate",
      }
  );

  filterOptionsModel.addOptions(
    "dateStart",
    CONTROL_TYPE.date,
    "shifts.START_DATE_LABEL",
    null,
    null,
    null,
    true
  );

  filterOptionsModel.addOptions(
    "endDate",
    CONTROL_TYPE.date,
    "shifts.END_DATE_LABEL",
    null,
    null,
    null,
    true
  );

  //Control centers
  const userRole = getUserRole();
  const isControlCenterManager = (userRole || []).some(item => item === USER_FILTER_ROLES.controlCenterManager);

  let selectControlCenterOption = filterOptionsModel.addOptions(FILTER_OPTION_TYPE.controlCenter, CONTROL_TYPE.select, i18n.t("shifts.CONTROL_CENTER"));
  selectControlCenterOption.selected = isControlCenterManager ? null : undefined;
  selectControlCenterOption.mappingLambda = state => [{ key: i18n.t("shifts.ALL"), value: null }].concat(
    sortUsers((state.restaurant && state.restaurant.data && state.restaurant.data.controlCenters) || [])
      .map(controlCenter=> ({
        key: controlCenter.name,
        value: controlCenter.controlCenterId
      }))
  );
  selectControlCenterOption.isShow = isShowControlCenterSearch;

  const filterState = Pusher.instance.getShiftProviderHistoryFilterStateChannel() || {}
  for(let key in filterState){
    filterOptionsModel.options[key].selected = filterState[key]?.selected ? filterState[key]?.selected : null
  }

  const {from, to} = prepareToday();
  filterOptionsModel.options["dateStart"].selected = from;
  filterOptionsModel.options["endDate"].selected = to;

  return filterOptionsModel;
}

function createShiftHistorySectionFilter() {
  let filterOptionsModel = new FilterOptionsModel();

  filterOptionsModel.addOptions("search", CONTROL_TYPE.text, null, function(
    order
  ) {
    return getShiftsHistoryFilter(this.selected, order);
  });

  return filterOptionsModel;
}

function createShiftHistoryTripSectionFilter() {
  let filterOptionsModel = new FilterOptionsModel();

  filterOptionsModel.addOptions(
      'states',
      CONTROL_TYPE.groupCheckbox,
      i18n.t('couriers.STATUS_TABLE_TITLE'),
      null,
      null,
      [
        {
          title: i18n.t('couriers.STATUS_TABLE_TITLE'),
          isCheckAllGroup: true,
          passEmptyFilters: true,
          filterType: FILTER_TYPE.and,
          items: Object.keys(EXTERNAL_CYCLE_STATE).map(key => ({
            name: `status-${EXTERNAL_CYCLE_STATE[key]}`,
            label: getExternalCourierState(EXTERNAL_CYCLE_STATE[key]),
            selected: true,
            filterType: FILTER_TYPE.or,
            value: EXTERNAL_CYCLE_STATE[key],
            filterFunction: order => true,
          }))
        },
      ],
      null,
      null,
      null,
      true
  )

  return filterOptionsModel;
}
